import { ref, computed } from 'vue'

export type LightboxImage = {
  src: string;
  alt?: string;
  caption?: string;
};

const isOpen = ref(false)
const currentImage = ref<LightboxImage | null>(null)

export function useLightbox () {
  function open (image: LightboxImage) {
    currentImage.value = image
    // bodyScrollLock(true);
    isOpen.value = true
    if (typeof document !== 'undefined') {
      document.documentElement.classList.add('overlay-open')
      document.body.classList.add('body--scroll-locked')
    }
  }

  function close () {
    isOpen.value = false
    // bodyScrollLock(false);
    currentImage.value = null
    if (typeof document !== 'undefined') {
      document.documentElement.classList.remove('overlay-open')
      document.body.classList.remove('body--scroll-locked')
    }
  }

  return {
    isOpen: computed(() => isOpen.value),
    currentImage: computed(() => currentImage.value),
    open,
    close
  }
}
